import { Component, OnInit } from '@angular/core';

declare var $: any;
declare var Nanobar: any;

@Component({
  selector: 'app-pending-driver',
  templateUrl: './pending-driver.component.html',
  styleUrls: ['./pending-driver.component.css']
})
export class PendingDriverComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $('.header').css('display', 'none');
    $('.footer').css('display', 'none');
    $('#sidebar').css('display', 'none');
  }

}



// WEBPACK FOOTER //
// ./src/app/pending-driver/pending-driver.component.ts